import $ from 'jquery';
import { getTypeDevice } from '../../utils/common';

const $wrapSliderListProducts = $('[data-wrap-products-slider-ui]');
let countSlide = {
  mobile  : 1,
  tablet  : 2,
  desktop : 3
};

if ($wrapSliderListProducts && $wrapSliderListProducts.length) {
  if ($wrapSliderListProducts.data('count-slide-products-slider-ui')) {
    countSlide = $wrapSliderListProducts.data('count-slide-products-slider-ui');
  }

  $wrapSliderListProducts.each((index, item) => {
    const $item = $(item);
    const $slider = $item.find('[data-products-slider-ui]');
    const showDotsMob = Boolean($slider.data('show-dots-mob-products-slider-ui'));

    if ($slider && $slider.childElementCount === 1) {
      $slider.classList.add('--single');
    }

    $slider.slick({
      slidesToShow   : countSlide.desktop,
      slidesToScroll : countSlide.desktop,

      nextArrow : $item.find('[data-products-slider-next]'),
      prevArrow : $item.find('[data-products-slider-prev]'),

      dots       : false,
      arrows     : true,
      infinite   : false,
      responsive : [
        {
          breakpoint : 1280,
          settings   : {
            slidesToShow   : countSlide.desktop,
            slidesToScroll : countSlide.desktop,
            dots           : false
          }
        },
        {
          breakpoint : 1024,
          settings   : {
            slidesToShow   : countSlide.tablet,
            slidesToScroll : countSlide.tablet,
            dots           : false
          }
        },
        {
          breakpoint : 768,
          settings   : {
            slidesToShow   : countSlide.mobile,
            slidesToScroll : countSlide.mobile,
            dots           : showDotsMob
          }
        }
      ]
    });
  });
}

const setVisibleArrow = (typeDevice) => {
  if ($wrapSliderListProducts && $wrapSliderListProducts.length) {
    $wrapSliderListProducts.each((index, element) => {
      const $section = $(element).closest('[data-section-products-slider-ui]');
      const countProducts = $section.data('section-products-slider-ui');

      if ($section && countProducts <= countSlide[typeDevice]) {
        $section.removeClass('active-arrow');
      }
      if ($section && countProducts > countSlide[typeDevice]) {
        $section.addClass('active-arrow');
      }
    });
  }
};

let typeDevice = getTypeDevice();
setVisibleArrow(typeDevice);

window.addEventListener('resize', () => {
  const newTypeDevice = getTypeDevice();

  if (typeDevice === newTypeDevice) {
    return;
  }

  typeDevice = newTypeDevice;

  setVisibleArrow(typeDevice);
});
